/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TenantCodeMarketRouteImport } from './routes/$tenantCode.$market'
import { Route as TenantCodeMarketIndexRouteImport } from './routes/$tenantCode.$market/index'
import { Route as TenantCodeMarketScanUploadsRouteImport } from './routes/$tenantCode.$market/scan-uploads'
import { Route as TenantCodeMarketScanToCorrectRouteImport } from './routes/$tenantCode.$market/scan-to-correct'
import { Route as TenantCodeMarketScanShippingBoxRouteImport } from './routes/$tenantCode.$market/scan-shipping-box'
import { Route as TenantCodeMarketScanControlRouteImport } from './routes/$tenantCode.$market/scan-control'
import { Route as TenantCodeMarketProductionLaboRouteImport } from './routes/$tenantCode.$market/production-labo'
import { Route as TenantCodeMarketPcrUploadsRouteImport } from './routes/$tenantCode.$market/pcr-uploads'
import { Route as TenantCodeMarketPcrInputAllRouteImport } from './routes/$tenantCode.$market/pcr-input-all'
import { Route as TenantCodeMarketPcrInputRouteImport } from './routes/$tenantCode.$market/pcr-input'
import { Route as TenantCodeMarketParcelsRouteImport } from './routes/$tenantCode.$market/parcels'
import { Route as TenantCodeMarketOrdersRouteImport } from './routes/$tenantCode.$market/orders'
import { Route as TenantCodeMarketOrderEntryClosesRouteImport } from './routes/$tenantCode.$market/order-entry-closes'
import { Route as TenantCodeMarketOrderDayRouteImport } from './routes/$tenantCode.$market/order-day'
import { Route as TenantCodeMarketOrderAddInfoRouteImport } from './routes/$tenantCode.$market/order-add-info'
import { Route as TenantCodeMarketListingFpRouteImport } from './routes/$tenantCode.$market/listing-fp'
import { Route as TenantCodeMarketDiamantReadyRouteImport } from './routes/$tenantCode.$market/diamant-ready'
import { Route as TenantCodeMarketDeliveryDelaysRouteImport } from './routes/$tenantCode.$market/delivery-delays'
import { Route as TenantCodeMarketDeliveryDelayProcessRouteImport } from './routes/$tenantCode.$market/delivery-delay-process'
import { Route as TenantCodeMarketBlModifiedFranceRouteImport } from './routes/$tenantCode.$market/bl-modified-france'
import { Route as TenantCodeMarketBlModifiedRouteImport } from './routes/$tenantCode.$market/bl-modified'
import { Route as TenantCodeMarketBlManualRouteImport } from './routes/$tenantCode.$market/bl-manual'
import { Route as TenantCodeMarketAnnexeUploadsRouteImport } from './routes/$tenantCode.$market/annexe-uploads'
import { Route as TenantCodeMarketAnnexeRouteImport } from './routes/$tenantCode.$market/annexe'
import { Route as TenantCodeMarketParcelsParcelIdRouteImport } from './routes/$tenantCode.$market/parcels_.$parcelId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantCodeMarketRoute = TenantCodeMarketRouteImport.update({
  id: '/$tenantCode/$market',
  path: '/$tenantCode/$market',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantCodeMarketIndexRoute = TenantCodeMarketIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TenantCodeMarketRoute,
} as any)
const TenantCodeMarketScanUploadsRoute =
  TenantCodeMarketScanUploadsRouteImport.update({
    id: '/scan-uploads',
    path: '/scan-uploads',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketScanToCorrectRoute =
  TenantCodeMarketScanToCorrectRouteImport.update({
    id: '/scan-to-correct',
    path: '/scan-to-correct',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketScanShippingBoxRoute =
  TenantCodeMarketScanShippingBoxRouteImport.update({
    id: '/scan-shipping-box',
    path: '/scan-shipping-box',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketScanControlRoute =
  TenantCodeMarketScanControlRouteImport.update({
    id: '/scan-control',
    path: '/scan-control',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketProductionLaboRoute =
  TenantCodeMarketProductionLaboRouteImport.update({
    id: '/production-labo',
    path: '/production-labo',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketPcrUploadsRoute =
  TenantCodeMarketPcrUploadsRouteImport.update({
    id: '/pcr-uploads',
    path: '/pcr-uploads',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketPcrInputAllRoute =
  TenantCodeMarketPcrInputAllRouteImport.update({
    id: '/pcr-input-all',
    path: '/pcr-input-all',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketPcrInputRoute =
  TenantCodeMarketPcrInputRouteImport.update({
    id: '/pcr-input',
    path: '/pcr-input',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketParcelsRoute = TenantCodeMarketParcelsRouteImport.update({
  id: '/parcels',
  path: '/parcels',
  getParentRoute: () => TenantCodeMarketRoute,
} as any)
const TenantCodeMarketOrdersRoute = TenantCodeMarketOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => TenantCodeMarketRoute,
} as any)
const TenantCodeMarketOrderEntryClosesRoute =
  TenantCodeMarketOrderEntryClosesRouteImport.update({
    id: '/order-entry-closes',
    path: '/order-entry-closes',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketOrderDayRoute =
  TenantCodeMarketOrderDayRouteImport.update({
    id: '/order-day',
    path: '/order-day',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketOrderAddInfoRoute =
  TenantCodeMarketOrderAddInfoRouteImport.update({
    id: '/order-add-info',
    path: '/order-add-info',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketListingFpRoute =
  TenantCodeMarketListingFpRouteImport.update({
    id: '/listing-fp',
    path: '/listing-fp',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketDiamantReadyRoute =
  TenantCodeMarketDiamantReadyRouteImport.update({
    id: '/diamant-ready',
    path: '/diamant-ready',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketDeliveryDelaysRoute =
  TenantCodeMarketDeliveryDelaysRouteImport.update({
    id: '/delivery-delays',
    path: '/delivery-delays',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketDeliveryDelayProcessRoute =
  TenantCodeMarketDeliveryDelayProcessRouteImport.update({
    id: '/delivery-delay-process',
    path: '/delivery-delay-process',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketBlModifiedFranceRoute =
  TenantCodeMarketBlModifiedFranceRouteImport.update({
    id: '/bl-modified-france',
    path: '/bl-modified-france',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketBlModifiedRoute =
  TenantCodeMarketBlModifiedRouteImport.update({
    id: '/bl-modified',
    path: '/bl-modified',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketBlManualRoute =
  TenantCodeMarketBlManualRouteImport.update({
    id: '/bl-manual',
    path: '/bl-manual',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketAnnexeUploadsRoute =
  TenantCodeMarketAnnexeUploadsRouteImport.update({
    id: '/annexe-uploads',
    path: '/annexe-uploads',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)
const TenantCodeMarketAnnexeRoute = TenantCodeMarketAnnexeRouteImport.update({
  id: '/annexe',
  path: '/annexe',
  getParentRoute: () => TenantCodeMarketRoute,
} as any)
const TenantCodeMarketParcelsParcelIdRoute =
  TenantCodeMarketParcelsParcelIdRouteImport.update({
    id: '/parcels_/$parcelId',
    path: '/parcels/$parcelId',
    getParentRoute: () => TenantCodeMarketRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$tenantCode/$market': typeof TenantCodeMarketRouteWithChildren
  '/$tenantCode/$market/annexe': typeof TenantCodeMarketAnnexeRoute
  '/$tenantCode/$market/annexe-uploads': typeof TenantCodeMarketAnnexeUploadsRoute
  '/$tenantCode/$market/bl-manual': typeof TenantCodeMarketBlManualRoute
  '/$tenantCode/$market/bl-modified': typeof TenantCodeMarketBlModifiedRoute
  '/$tenantCode/$market/bl-modified-france': typeof TenantCodeMarketBlModifiedFranceRoute
  '/$tenantCode/$market/delivery-delay-process': typeof TenantCodeMarketDeliveryDelayProcessRoute
  '/$tenantCode/$market/delivery-delays': typeof TenantCodeMarketDeliveryDelaysRoute
  '/$tenantCode/$market/diamant-ready': typeof TenantCodeMarketDiamantReadyRoute
  '/$tenantCode/$market/listing-fp': typeof TenantCodeMarketListingFpRoute
  '/$tenantCode/$market/order-add-info': typeof TenantCodeMarketOrderAddInfoRoute
  '/$tenantCode/$market/order-day': typeof TenantCodeMarketOrderDayRoute
  '/$tenantCode/$market/order-entry-closes': typeof TenantCodeMarketOrderEntryClosesRoute
  '/$tenantCode/$market/orders': typeof TenantCodeMarketOrdersRoute
  '/$tenantCode/$market/parcels': typeof TenantCodeMarketParcelsRoute
  '/$tenantCode/$market/pcr-input': typeof TenantCodeMarketPcrInputRoute
  '/$tenantCode/$market/pcr-input-all': typeof TenantCodeMarketPcrInputAllRoute
  '/$tenantCode/$market/pcr-uploads': typeof TenantCodeMarketPcrUploadsRoute
  '/$tenantCode/$market/production-labo': typeof TenantCodeMarketProductionLaboRoute
  '/$tenantCode/$market/scan-control': typeof TenantCodeMarketScanControlRoute
  '/$tenantCode/$market/scan-shipping-box': typeof TenantCodeMarketScanShippingBoxRoute
  '/$tenantCode/$market/scan-to-correct': typeof TenantCodeMarketScanToCorrectRoute
  '/$tenantCode/$market/scan-uploads': typeof TenantCodeMarketScanUploadsRoute
  '/$tenantCode/$market/': typeof TenantCodeMarketIndexRoute
  '/$tenantCode/$market/parcels/$parcelId': typeof TenantCodeMarketParcelsParcelIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$tenantCode/$market/annexe': typeof TenantCodeMarketAnnexeRoute
  '/$tenantCode/$market/annexe-uploads': typeof TenantCodeMarketAnnexeUploadsRoute
  '/$tenantCode/$market/bl-manual': typeof TenantCodeMarketBlManualRoute
  '/$tenantCode/$market/bl-modified': typeof TenantCodeMarketBlModifiedRoute
  '/$tenantCode/$market/bl-modified-france': typeof TenantCodeMarketBlModifiedFranceRoute
  '/$tenantCode/$market/delivery-delay-process': typeof TenantCodeMarketDeliveryDelayProcessRoute
  '/$tenantCode/$market/delivery-delays': typeof TenantCodeMarketDeliveryDelaysRoute
  '/$tenantCode/$market/diamant-ready': typeof TenantCodeMarketDiamantReadyRoute
  '/$tenantCode/$market/listing-fp': typeof TenantCodeMarketListingFpRoute
  '/$tenantCode/$market/order-add-info': typeof TenantCodeMarketOrderAddInfoRoute
  '/$tenantCode/$market/order-day': typeof TenantCodeMarketOrderDayRoute
  '/$tenantCode/$market/order-entry-closes': typeof TenantCodeMarketOrderEntryClosesRoute
  '/$tenantCode/$market/orders': typeof TenantCodeMarketOrdersRoute
  '/$tenantCode/$market/parcels': typeof TenantCodeMarketParcelsRoute
  '/$tenantCode/$market/pcr-input': typeof TenantCodeMarketPcrInputRoute
  '/$tenantCode/$market/pcr-input-all': typeof TenantCodeMarketPcrInputAllRoute
  '/$tenantCode/$market/pcr-uploads': typeof TenantCodeMarketPcrUploadsRoute
  '/$tenantCode/$market/production-labo': typeof TenantCodeMarketProductionLaboRoute
  '/$tenantCode/$market/scan-control': typeof TenantCodeMarketScanControlRoute
  '/$tenantCode/$market/scan-shipping-box': typeof TenantCodeMarketScanShippingBoxRoute
  '/$tenantCode/$market/scan-to-correct': typeof TenantCodeMarketScanToCorrectRoute
  '/$tenantCode/$market/scan-uploads': typeof TenantCodeMarketScanUploadsRoute
  '/$tenantCode/$market': typeof TenantCodeMarketIndexRoute
  '/$tenantCode/$market/parcels/$parcelId': typeof TenantCodeMarketParcelsParcelIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$tenantCode/$market': typeof TenantCodeMarketRouteWithChildren
  '/$tenantCode/$market/annexe': typeof TenantCodeMarketAnnexeRoute
  '/$tenantCode/$market/annexe-uploads': typeof TenantCodeMarketAnnexeUploadsRoute
  '/$tenantCode/$market/bl-manual': typeof TenantCodeMarketBlManualRoute
  '/$tenantCode/$market/bl-modified': typeof TenantCodeMarketBlModifiedRoute
  '/$tenantCode/$market/bl-modified-france': typeof TenantCodeMarketBlModifiedFranceRoute
  '/$tenantCode/$market/delivery-delay-process': typeof TenantCodeMarketDeliveryDelayProcessRoute
  '/$tenantCode/$market/delivery-delays': typeof TenantCodeMarketDeliveryDelaysRoute
  '/$tenantCode/$market/diamant-ready': typeof TenantCodeMarketDiamantReadyRoute
  '/$tenantCode/$market/listing-fp': typeof TenantCodeMarketListingFpRoute
  '/$tenantCode/$market/order-add-info': typeof TenantCodeMarketOrderAddInfoRoute
  '/$tenantCode/$market/order-day': typeof TenantCodeMarketOrderDayRoute
  '/$tenantCode/$market/order-entry-closes': typeof TenantCodeMarketOrderEntryClosesRoute
  '/$tenantCode/$market/orders': typeof TenantCodeMarketOrdersRoute
  '/$tenantCode/$market/parcels': typeof TenantCodeMarketParcelsRoute
  '/$tenantCode/$market/pcr-input': typeof TenantCodeMarketPcrInputRoute
  '/$tenantCode/$market/pcr-input-all': typeof TenantCodeMarketPcrInputAllRoute
  '/$tenantCode/$market/pcr-uploads': typeof TenantCodeMarketPcrUploadsRoute
  '/$tenantCode/$market/production-labo': typeof TenantCodeMarketProductionLaboRoute
  '/$tenantCode/$market/scan-control': typeof TenantCodeMarketScanControlRoute
  '/$tenantCode/$market/scan-shipping-box': typeof TenantCodeMarketScanShippingBoxRoute
  '/$tenantCode/$market/scan-to-correct': typeof TenantCodeMarketScanToCorrectRoute
  '/$tenantCode/$market/scan-uploads': typeof TenantCodeMarketScanUploadsRoute
  '/$tenantCode/$market/': typeof TenantCodeMarketIndexRoute
  '/$tenantCode/$market/parcels_/$parcelId': typeof TenantCodeMarketParcelsParcelIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$tenantCode/$market'
    | '/$tenantCode/$market/annexe'
    | '/$tenantCode/$market/annexe-uploads'
    | '/$tenantCode/$market/bl-manual'
    | '/$tenantCode/$market/bl-modified'
    | '/$tenantCode/$market/bl-modified-france'
    | '/$tenantCode/$market/delivery-delay-process'
    | '/$tenantCode/$market/delivery-delays'
    | '/$tenantCode/$market/diamant-ready'
    | '/$tenantCode/$market/listing-fp'
    | '/$tenantCode/$market/order-add-info'
    | '/$tenantCode/$market/order-day'
    | '/$tenantCode/$market/order-entry-closes'
    | '/$tenantCode/$market/orders'
    | '/$tenantCode/$market/parcels'
    | '/$tenantCode/$market/pcr-input'
    | '/$tenantCode/$market/pcr-input-all'
    | '/$tenantCode/$market/pcr-uploads'
    | '/$tenantCode/$market/production-labo'
    | '/$tenantCode/$market/scan-control'
    | '/$tenantCode/$market/scan-shipping-box'
    | '/$tenantCode/$market/scan-to-correct'
    | '/$tenantCode/$market/scan-uploads'
    | '/$tenantCode/$market/'
    | '/$tenantCode/$market/parcels/$parcelId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$tenantCode/$market/annexe'
    | '/$tenantCode/$market/annexe-uploads'
    | '/$tenantCode/$market/bl-manual'
    | '/$tenantCode/$market/bl-modified'
    | '/$tenantCode/$market/bl-modified-france'
    | '/$tenantCode/$market/delivery-delay-process'
    | '/$tenantCode/$market/delivery-delays'
    | '/$tenantCode/$market/diamant-ready'
    | '/$tenantCode/$market/listing-fp'
    | '/$tenantCode/$market/order-add-info'
    | '/$tenantCode/$market/order-day'
    | '/$tenantCode/$market/order-entry-closes'
    | '/$tenantCode/$market/orders'
    | '/$tenantCode/$market/parcels'
    | '/$tenantCode/$market/pcr-input'
    | '/$tenantCode/$market/pcr-input-all'
    | '/$tenantCode/$market/pcr-uploads'
    | '/$tenantCode/$market/production-labo'
    | '/$tenantCode/$market/scan-control'
    | '/$tenantCode/$market/scan-shipping-box'
    | '/$tenantCode/$market/scan-to-correct'
    | '/$tenantCode/$market/scan-uploads'
    | '/$tenantCode/$market'
    | '/$tenantCode/$market/parcels/$parcelId'
  id:
    | '__root__'
    | '/'
    | '/$tenantCode/$market'
    | '/$tenantCode/$market/annexe'
    | '/$tenantCode/$market/annexe-uploads'
    | '/$tenantCode/$market/bl-manual'
    | '/$tenantCode/$market/bl-modified'
    | '/$tenantCode/$market/bl-modified-france'
    | '/$tenantCode/$market/delivery-delay-process'
    | '/$tenantCode/$market/delivery-delays'
    | '/$tenantCode/$market/diamant-ready'
    | '/$tenantCode/$market/listing-fp'
    | '/$tenantCode/$market/order-add-info'
    | '/$tenantCode/$market/order-day'
    | '/$tenantCode/$market/order-entry-closes'
    | '/$tenantCode/$market/orders'
    | '/$tenantCode/$market/parcels'
    | '/$tenantCode/$market/pcr-input'
    | '/$tenantCode/$market/pcr-input-all'
    | '/$tenantCode/$market/pcr-uploads'
    | '/$tenantCode/$market/production-labo'
    | '/$tenantCode/$market/scan-control'
    | '/$tenantCode/$market/scan-shipping-box'
    | '/$tenantCode/$market/scan-to-correct'
    | '/$tenantCode/$market/scan-uploads'
    | '/$tenantCode/$market/'
    | '/$tenantCode/$market/parcels_/$parcelId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TenantCodeMarketRoute: typeof TenantCodeMarketRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantCode/$market': {
      id: '/$tenantCode/$market'
      path: '/$tenantCode/$market'
      fullPath: '/$tenantCode/$market'
      preLoaderRoute: typeof TenantCodeMarketRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantCode/$market/': {
      id: '/$tenantCode/$market/'
      path: '/'
      fullPath: '/$tenantCode/$market/'
      preLoaderRoute: typeof TenantCodeMarketIndexRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/scan-uploads': {
      id: '/$tenantCode/$market/scan-uploads'
      path: '/scan-uploads'
      fullPath: '/$tenantCode/$market/scan-uploads'
      preLoaderRoute: typeof TenantCodeMarketScanUploadsRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/scan-to-correct': {
      id: '/$tenantCode/$market/scan-to-correct'
      path: '/scan-to-correct'
      fullPath: '/$tenantCode/$market/scan-to-correct'
      preLoaderRoute: typeof TenantCodeMarketScanToCorrectRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/scan-shipping-box': {
      id: '/$tenantCode/$market/scan-shipping-box'
      path: '/scan-shipping-box'
      fullPath: '/$tenantCode/$market/scan-shipping-box'
      preLoaderRoute: typeof TenantCodeMarketScanShippingBoxRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/scan-control': {
      id: '/$tenantCode/$market/scan-control'
      path: '/scan-control'
      fullPath: '/$tenantCode/$market/scan-control'
      preLoaderRoute: typeof TenantCodeMarketScanControlRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/production-labo': {
      id: '/$tenantCode/$market/production-labo'
      path: '/production-labo'
      fullPath: '/$tenantCode/$market/production-labo'
      preLoaderRoute: typeof TenantCodeMarketProductionLaboRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/pcr-uploads': {
      id: '/$tenantCode/$market/pcr-uploads'
      path: '/pcr-uploads'
      fullPath: '/$tenantCode/$market/pcr-uploads'
      preLoaderRoute: typeof TenantCodeMarketPcrUploadsRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/pcr-input-all': {
      id: '/$tenantCode/$market/pcr-input-all'
      path: '/pcr-input-all'
      fullPath: '/$tenantCode/$market/pcr-input-all'
      preLoaderRoute: typeof TenantCodeMarketPcrInputAllRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/pcr-input': {
      id: '/$tenantCode/$market/pcr-input'
      path: '/pcr-input'
      fullPath: '/$tenantCode/$market/pcr-input'
      preLoaderRoute: typeof TenantCodeMarketPcrInputRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/parcels': {
      id: '/$tenantCode/$market/parcels'
      path: '/parcels'
      fullPath: '/$tenantCode/$market/parcels'
      preLoaderRoute: typeof TenantCodeMarketParcelsRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/orders': {
      id: '/$tenantCode/$market/orders'
      path: '/orders'
      fullPath: '/$tenantCode/$market/orders'
      preLoaderRoute: typeof TenantCodeMarketOrdersRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/order-entry-closes': {
      id: '/$tenantCode/$market/order-entry-closes'
      path: '/order-entry-closes'
      fullPath: '/$tenantCode/$market/order-entry-closes'
      preLoaderRoute: typeof TenantCodeMarketOrderEntryClosesRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/order-day': {
      id: '/$tenantCode/$market/order-day'
      path: '/order-day'
      fullPath: '/$tenantCode/$market/order-day'
      preLoaderRoute: typeof TenantCodeMarketOrderDayRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/order-add-info': {
      id: '/$tenantCode/$market/order-add-info'
      path: '/order-add-info'
      fullPath: '/$tenantCode/$market/order-add-info'
      preLoaderRoute: typeof TenantCodeMarketOrderAddInfoRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/listing-fp': {
      id: '/$tenantCode/$market/listing-fp'
      path: '/listing-fp'
      fullPath: '/$tenantCode/$market/listing-fp'
      preLoaderRoute: typeof TenantCodeMarketListingFpRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/diamant-ready': {
      id: '/$tenantCode/$market/diamant-ready'
      path: '/diamant-ready'
      fullPath: '/$tenantCode/$market/diamant-ready'
      preLoaderRoute: typeof TenantCodeMarketDiamantReadyRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/delivery-delays': {
      id: '/$tenantCode/$market/delivery-delays'
      path: '/delivery-delays'
      fullPath: '/$tenantCode/$market/delivery-delays'
      preLoaderRoute: typeof TenantCodeMarketDeliveryDelaysRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/delivery-delay-process': {
      id: '/$tenantCode/$market/delivery-delay-process'
      path: '/delivery-delay-process'
      fullPath: '/$tenantCode/$market/delivery-delay-process'
      preLoaderRoute: typeof TenantCodeMarketDeliveryDelayProcessRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/bl-modified-france': {
      id: '/$tenantCode/$market/bl-modified-france'
      path: '/bl-modified-france'
      fullPath: '/$tenantCode/$market/bl-modified-france'
      preLoaderRoute: typeof TenantCodeMarketBlModifiedFranceRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/bl-modified': {
      id: '/$tenantCode/$market/bl-modified'
      path: '/bl-modified'
      fullPath: '/$tenantCode/$market/bl-modified'
      preLoaderRoute: typeof TenantCodeMarketBlModifiedRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/bl-manual': {
      id: '/$tenantCode/$market/bl-manual'
      path: '/bl-manual'
      fullPath: '/$tenantCode/$market/bl-manual'
      preLoaderRoute: typeof TenantCodeMarketBlManualRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/annexe-uploads': {
      id: '/$tenantCode/$market/annexe-uploads'
      path: '/annexe-uploads'
      fullPath: '/$tenantCode/$market/annexe-uploads'
      preLoaderRoute: typeof TenantCodeMarketAnnexeUploadsRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/annexe': {
      id: '/$tenantCode/$market/annexe'
      path: '/annexe'
      fullPath: '/$tenantCode/$market/annexe'
      preLoaderRoute: typeof TenantCodeMarketAnnexeRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
    '/$tenantCode/$market/parcels_/$parcelId': {
      id: '/$tenantCode/$market/parcels_/$parcelId'
      path: '/parcels/$parcelId'
      fullPath: '/$tenantCode/$market/parcels/$parcelId'
      preLoaderRoute: typeof TenantCodeMarketParcelsParcelIdRouteImport
      parentRoute: typeof TenantCodeMarketRoute
    }
  }
}

interface TenantCodeMarketRouteChildren {
  TenantCodeMarketAnnexeRoute: typeof TenantCodeMarketAnnexeRoute
  TenantCodeMarketAnnexeUploadsRoute: typeof TenantCodeMarketAnnexeUploadsRoute
  TenantCodeMarketBlManualRoute: typeof TenantCodeMarketBlManualRoute
  TenantCodeMarketBlModifiedRoute: typeof TenantCodeMarketBlModifiedRoute
  TenantCodeMarketBlModifiedFranceRoute: typeof TenantCodeMarketBlModifiedFranceRoute
  TenantCodeMarketDeliveryDelayProcessRoute: typeof TenantCodeMarketDeliveryDelayProcessRoute
  TenantCodeMarketDeliveryDelaysRoute: typeof TenantCodeMarketDeliveryDelaysRoute
  TenantCodeMarketDiamantReadyRoute: typeof TenantCodeMarketDiamantReadyRoute
  TenantCodeMarketListingFpRoute: typeof TenantCodeMarketListingFpRoute
  TenantCodeMarketOrderAddInfoRoute: typeof TenantCodeMarketOrderAddInfoRoute
  TenantCodeMarketOrderDayRoute: typeof TenantCodeMarketOrderDayRoute
  TenantCodeMarketOrderEntryClosesRoute: typeof TenantCodeMarketOrderEntryClosesRoute
  TenantCodeMarketOrdersRoute: typeof TenantCodeMarketOrdersRoute
  TenantCodeMarketParcelsRoute: typeof TenantCodeMarketParcelsRoute
  TenantCodeMarketPcrInputRoute: typeof TenantCodeMarketPcrInputRoute
  TenantCodeMarketPcrInputAllRoute: typeof TenantCodeMarketPcrInputAllRoute
  TenantCodeMarketPcrUploadsRoute: typeof TenantCodeMarketPcrUploadsRoute
  TenantCodeMarketProductionLaboRoute: typeof TenantCodeMarketProductionLaboRoute
  TenantCodeMarketScanControlRoute: typeof TenantCodeMarketScanControlRoute
  TenantCodeMarketScanShippingBoxRoute: typeof TenantCodeMarketScanShippingBoxRoute
  TenantCodeMarketScanToCorrectRoute: typeof TenantCodeMarketScanToCorrectRoute
  TenantCodeMarketScanUploadsRoute: typeof TenantCodeMarketScanUploadsRoute
  TenantCodeMarketIndexRoute: typeof TenantCodeMarketIndexRoute
  TenantCodeMarketParcelsParcelIdRoute: typeof TenantCodeMarketParcelsParcelIdRoute
}

const TenantCodeMarketRouteChildren: TenantCodeMarketRouteChildren = {
  TenantCodeMarketAnnexeRoute: TenantCodeMarketAnnexeRoute,
  TenantCodeMarketAnnexeUploadsRoute: TenantCodeMarketAnnexeUploadsRoute,
  TenantCodeMarketBlManualRoute: TenantCodeMarketBlManualRoute,
  TenantCodeMarketBlModifiedRoute: TenantCodeMarketBlModifiedRoute,
  TenantCodeMarketBlModifiedFranceRoute: TenantCodeMarketBlModifiedFranceRoute,
  TenantCodeMarketDeliveryDelayProcessRoute:
    TenantCodeMarketDeliveryDelayProcessRoute,
  TenantCodeMarketDeliveryDelaysRoute: TenantCodeMarketDeliveryDelaysRoute,
  TenantCodeMarketDiamantReadyRoute: TenantCodeMarketDiamantReadyRoute,
  TenantCodeMarketListingFpRoute: TenantCodeMarketListingFpRoute,
  TenantCodeMarketOrderAddInfoRoute: TenantCodeMarketOrderAddInfoRoute,
  TenantCodeMarketOrderDayRoute: TenantCodeMarketOrderDayRoute,
  TenantCodeMarketOrderEntryClosesRoute: TenantCodeMarketOrderEntryClosesRoute,
  TenantCodeMarketOrdersRoute: TenantCodeMarketOrdersRoute,
  TenantCodeMarketParcelsRoute: TenantCodeMarketParcelsRoute,
  TenantCodeMarketPcrInputRoute: TenantCodeMarketPcrInputRoute,
  TenantCodeMarketPcrInputAllRoute: TenantCodeMarketPcrInputAllRoute,
  TenantCodeMarketPcrUploadsRoute: TenantCodeMarketPcrUploadsRoute,
  TenantCodeMarketProductionLaboRoute: TenantCodeMarketProductionLaboRoute,
  TenantCodeMarketScanControlRoute: TenantCodeMarketScanControlRoute,
  TenantCodeMarketScanShippingBoxRoute: TenantCodeMarketScanShippingBoxRoute,
  TenantCodeMarketScanToCorrectRoute: TenantCodeMarketScanToCorrectRoute,
  TenantCodeMarketScanUploadsRoute: TenantCodeMarketScanUploadsRoute,
  TenantCodeMarketIndexRoute: TenantCodeMarketIndexRoute,
  TenantCodeMarketParcelsParcelIdRoute: TenantCodeMarketParcelsParcelIdRoute,
}

const TenantCodeMarketRouteWithChildren =
  TenantCodeMarketRoute._addFileChildren(TenantCodeMarketRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TenantCodeMarketRoute: TenantCodeMarketRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
